import type { TicketVenue } from '@app-types/ticketSales';
import type { ImmerStateCreator } from '../../immerStateCreator';
import { createShowsSlice, type ShowsStore, type TicketingSalesShow } from './shows';

export type TicketingSalesVenue = Omit<TicketVenue, 'shows'> & {
  showsById: Record<string, TicketingSalesShow>;
  showsIdOrder: string[];
};

export interface VenuesState {
  venuesById: Record<string, TicketingSalesVenue>;
  venuesIdOrder: string[];
}

export interface VenuesActions {
  initializeVenues: (venues: TicketVenue[]) => void;
}

export type VenuesStore = VenuesState & VenuesActions & ShowsStore;

export const createVenuesSlice: ImmerStateCreator<VenuesStore> = (set, get, store) => ({
  venuesById: {},
  venuesIdOrder: [],
  initializeVenues: (venues) =>
    set(
      (state) => {
        state.venuesById = {};
        state.venuesIdOrder = venues.map((venue) => venue.id);

        venues.forEach(({ shows: _shows, ...venue }) => {
          state.venuesById[venue.id] = {
            ...venue,
            showsById: {},
            showsIdOrder: [],
          };
        });
      },
      false,
      'ticketingSales/initializeVenues',
    ),
  ...createShowsSlice(...([set, get, store] as Parameters<typeof createShowsSlice>)),
});
